module.exports = __webpack_public_path__ + "img/3.667c1508.jpg";